import React from 'react'
import { Button } from 'antd'
import './style.scss'

class AppFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__top">
          <div className="row">
            <div className="col-lg-9">
              <p>
                <strong>GrowLINK - Best Solution for Your Recruitment!</strong>
              </p>
              <p>                
                GrowLINK is a powerful and super flexible tool, which suits best for any kind of Recruitment
                application: Dashboard; Offers; etc. GrowLINK is
                fully responsive, which means that it looks perfect on mobiles and tablets.
              </p>
              <p>
                GrowLINK is fully based on Big Data and Date mining, includes 10+ Algorithme of segmentation.                
              </p>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="row">
            <div className="col-sm-6">
              <a
                href="https://www.datech.io"
                target="_blank"
                rel="noopener noreferrer"
                className="mr-4"
              >
                <Button type="primary">Buy Now 25$</Button>
              </a>
            </div>
            <div className="col-sm-6">
              <div className="footer__copyright">
                <img
                  src="resources/images/mediatec.png"
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="GrowLink SAS"
                />
                <span>
                  © 2018{' '}
                  <a href="https://growlink.io/" target="_blank" rel="noopener noreferrer">
                    GrowLink SAS
                  </a>
                  <br />
                  All rights reserved
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppFooter



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Footer/index.js